export class MoodLogs {
  id?: number;
  mood: string;
  dateTime: Date;
  patientId?: number;
  comment?: string;
  image?: string;
  moodId: number;
  cellBgndClass: string;
  others: MoodLogs[];
  dateString?: string;
  timeOfCreation?: string;
}
